import { DealerInfo, LocationFilterParams } from '../stores/products/products.connection';
import { computed, Ref } from 'vue';
import { FilterCode, ProductFilterTypes } from '../models/product-filter/product-filter-base.model';
import { IProductFilterType } from '../models/product-filter/product-filter.model';

export const useTrackingFilterQueryString = (
  locationFilterParams: Ref<LocationFilterParams | null>,
  dealerFilterInfo: Ref<DealerInfo | null>,
) => {
  /**
   * Get tracking for currently selected location / dealer filter
   */
  const locationTrackingValue = computed((): string => {
    if (locationFilterParams.value) {
      return `${locationFilterParams.value.search}_${locationFilterParams.value.distance
        .replace(/\s/g, '')
        .toLowerCase()}`;
    } else if (dealerFilterInfo.value) {
      return dealerFilterInfo.value.id;
    } else {
      return '';
    }
  });

  /**
   * From the selected filters build an object with the correct format, depending on the filter type
   * or filter values - to be sent to the analytics.
   */
  const createQueryStringFilterValue = (filters: IProductFilterType[]) => {
    const queryStringFilters: {
      type: string;
      name: string;
      value: string;
    }[] = [];

    const addTrackingQueryStringFilter = (filter: IProductFilterType, filterValue: any) => {
      queryStringFilters.push({
        type: ProductFilterTypes[filter.type] ?? filter.type,
        name: filter.code,
        value: filterValue,
      });
    };

    filters.forEach((filter) => {
      const filterTypeName = ProductFilterTypes[filter.type];

      if (filter.code === FilterCode.locations) {
        addTrackingQueryStringFilter(filter, locationTrackingValue.value || filter.value);

        return;
      }

      // handle slider filter values, that require a special value formatting.
      if (filterTypeName === 'Slider') {
        addTrackingQueryStringFilter(filter, filter.value?.join('-'));

        return;
      }

      // handle array filter values
      filter.value.forEach((value: any) => addTrackingQueryStringFilter(filter, value));
    });

    return queryStringFilters;
  };

  return {
    createQueryStringFilterValue,
  };
};
